import React, { useState } from "react";
import ProductsRow from "../ProductsRow/index";
import { Button, Accordion, Form } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import "./styles.scss";
import { getCategoryDropdown } from "../../../../components/helper";

export default (props) => {
  const {
    products,
    setProducts,
    fetchProducts,
    categories,
    productsCount,
    subCategories,
    addSubCategory,
  } = props;
  const [searchString, setSearchString] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [pageNo, setPageNo] = useState(1);

  const addNewProducts = () => {
    const newProduct = Object.assign([], products);
    newProduct.push({
      category_id: null,
    });
    setProducts(newProduct);
  };

  const deteleEmptyProduct = () => {
    const newProduct = Object.assign([], products);
    newProduct.pop();
    setProducts(newProduct);
  };
  return (
    <>
      <h2 className="pt-3 pl-3">Products</h2>
      <div className="p-5">
        <div>
          <p>All prices are in Indian Ruppess</p>
          <p>1) Name is a mandatory field</p>
          <p>2) Category is a mandatory selection</p>
          <p>3) Weight is a mandatory field</p>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <Form.Group className="w-75">
          <Form.Control
            value={searchString || ""}
            onChange={async (event) => {
              const {
                target: { value },
              } = event;
              setSearchString(value === "" ? null : value);
              await fetchProducts(value === "" ? null : value, categoryId, 1);
            }}
            placeholder="Search product"
            type="text"
          />
        </Form.Group>
        <div>
          {getCategoryDropdown(categories, categoryId, async (element) => {
            setCategoryId(element.category_id);
            await fetchProducts(searchString, element.category_id, 1);
          })}
        </div>
      </div>

      {products && products.length > 0 ? (
        products.map((element) => (
          <Accordion>
            <ProductsRow
              product={element}
              categories={categories}
              deteleEmptyProduct={deteleEmptyProduct}
              fetchProducts={fetchProducts}
              key={element.product_id || Date.now().toString()}
              subCategories={subCategories}
              addSubCategory={addSubCategory}
              searchString={searchString}
              searchCategoryFilter={categoryId}
              activePageNo={pageNo}
              setProducts={setProducts}
              products={products}
            />
          </Accordion>
        ))
      ) : (
        <h2 className="text-center">No products found</h2>
      )}
      <div className="d-flex justify-content-center">
        <Button onClick={addNewProducts}>Add Product</Button>
      </div>
      <div className="d-flex justify-content-center mt-5">
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={productsCount / 20}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={async (data) => {
            setPageNo(data.selected + 1);
            await fetchProducts(searchString, categoryId, data.selected + 1);
          }}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};
